import { render, staticRenderFns } from "./DeleteSkillDialog.vue?vue&type=template&id=4d013f38"
import script from "./DeleteSkillDialog.vue?vue&type=script&lang=js"
export * from "./DeleteSkillDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports